import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
interface TrustRowProps {
  variant?: 'light' | 'dark';
  guaranteeLabel?: string;
}
export function TrustRow({
  variant = 'light',
  guaranteeLabel = '14-Day Money-Back Guarantee'
}: TrustRowProps) {
  const text = variant === 'light' ? 'text-eq-navy' : 'text-white/90';
  return <div className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[11px] font-bold sm:text-sm ${text}`} data-id="element-162" data-mp="2cq68bf78nryf">
      <span className="flex items-center gap-1" data-id="element-163" data-mp="1k0yyvl68xhye">
        <span className="flex gap-0.5" aria-hidden="true" data-id="element-164" data-mp="1k2a1virvalog">
          {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-eq-gold text-eq-gold" data-id="element-165" data-mp="1yzkkrd6uatu7" />)}
        </span>
        4.9/5 — Verified Customer Reviews
      </span>
      <span className="flex items-center gap-1" data-id="element-166" data-mp="3acdbcknw9c8o">
        <ShieldCheckIcon className="h-4 w-4 text-eq-gold" aria-hidden="true" data-id="element-167" data-mp="3af99a8zqs0x4" />
        {guaranteeLabel}
      </span>
    </div>;
}